// export const SONGADAY_CONTRACT_ADDRESS = '0x99e3106fe0ffabF45069582c5153a245146ff405';
export const SONGADAY_CONTRACT_ADDRESS =
  process.env.SONGADAY_CONTRACT_ADDRESS ?? '0x19b703f65aA7E1E775BD06c2aa0D0d08c80f1C45';
export const DAO_ADDRESS = '0x2a2C412c440Dfb0E7cae46EFF581e3E26aFd1Cd0';
// export const SONGADAY_CONTRACT_ADDRESS =
//   process.env.SONGADAY_CONTRACT_ADDRESS ?? '0x77560985d80A3e2460cA950B2Fe437537fE1E2f2';
// export const SONGADAY_CONTRACT_ADDRESS = '0x0b0c157a275b749d8df3154bf45b1702927e6cbc';
export const OPENSTORE_CONTRACT_ADDRESS = '0x495f947276749ce646f68ac8c248420045cb7b5e';
export const PUBLIC_MINT_SUPPLY = 4748;
export const BURN_COLLECTION = 'song-a-dao';
export const RESERVE_PRICE = '0.000000001';
